module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Details")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Regions")]), _vm._v(" "), _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Logo")]), _vm._v(" "), _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Bank Details")]), _vm._v(" "), _c('v-tab', {
    key: 5,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("T's & C's")]), _vm._v(" "), _c('v-tab', {
    key: 6,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Store Pricelists")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-0 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Store Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name",
      "required": "",
      "rules": _vm.nameRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchName),
      callback: function($$v) {
        _vm.branchName = $$v
      },
      expression: "branchName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Store Code:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Branch Code",
      "required": "",
      "rules": _vm.codeRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchCode),
      callback: function($$v) {
        _vm.branchCode = $$v
      },
      expression: "branchCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Store Email:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "required": "",
      "rules": _vm.emailRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchEmail),
      callback: function($$v) {
        _vm.branchEmail = $$v
      },
      expression: "branchEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Store Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Description",
      "required": "",
      "rules": _vm.descriptionRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchDescription),
      callback: function($$v) {
        _vm.branchDescription = $$v
      },
      expression: "branchDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Store Street Address 1:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Street Address 1",
      "required": "",
      "rules": _vm.addressRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchAddressOne),
      callback: function($$v) {
        _vm.branchAddressOne = $$v
      },
      expression: "branchAddressOne"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Store Street Address 2:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Street Address 2",
      "required": "",
      "rules": _vm.addressRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchAddressTwo),
      callback: function($$v) {
        _vm.branchAddressTwo = $$v
      },
      expression: "branchAddressTwo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Store Postal Code:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Postal Code",
      "required": "",
      "rules": _vm.addressRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchPostalCode),
      callback: function($$v) {
        _vm.branchPostalCode = $$v
      },
      expression: "branchPostalCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Store Contact Number:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Contact Number",
      "required": "",
      "rules": _vm.contactRules,
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchContact),
      callback: function($$v) {
        _vm.branchContact = $$v
      },
      expression: "branchContact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Store Override Main Details:")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchSwitch),
      callback: function($$v) {
        _vm.branchSwitch = $$v
      },
      expression: "branchSwitch"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('div', {
    staticClass: "screenTip"
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v("\n                            Trade Rep is a rep linked to a specific customer for a specific store.  If one is not linked this rep will be used by default.\n                          ")])]), _vm._v(" "), _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Trade Rep:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.repsShortList,
      "item-value": "userid",
      "item-text": "full_name",
      "label": "Trade Rep",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchTradeRep),
      callback: function($$v) {
        _vm.branchTradeRep = $$v
      },
      expression: "branchTradeRep"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.userRegions != '') ? _c('v-data-table', {
    staticClass: "elevation-1 mainTable",
    attrs: {
      "headers": _vm.regionHeader,
      "search": _vm.search,
      "id": "hello",
      "items": _vm.userRegions,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [2000, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('v-switch', {
          on: {
            "change": function($event) {
              return _vm.fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)
            }
          },
          model: {
            value: (props.item.selected),
            callback: function($$v) {
              _vm.$set(props.item, "selected", $$v)
            },
            expression: "props.item.selected"
          }
        })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
          staticClass: "cursor",
          attrs: {
            "width": "95%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
          staticClass: "cursor",
          attrs: {
            "width": "95%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_downward")]) : _vm._e()])])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [(props.item.children != '') ? _c('v-data-table', {
          staticClass: "elevation-1 subTable subTable1",
          attrs: {
            "headers": _vm.regionHeader,
            "search": _vm.search,
            "items": props.item.children,
            "hide-actions": "",
            "disable-initial-sort": "",
            "rows-per-page-items": [20, 40, 60, 80, 100]
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return [_c('tr', [_c('td', {
                staticClass: "levelone",
                attrs: {
                  "width": "5%"
                }
              }, [_c('v-switch', {
                on: {
                  "change": function($event) {
                    return _vm.fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)
                  }
                },
                model: {
                  value: (props.item.selected),
                  callback: function($$v) {
                    _vm.$set(props.item, "selected", $$v)
                  },
                  expression: "props.item.selected"
                }
              })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
                staticClass: "cursor",
                attrs: {
                  "width": "95%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
                staticClass: "cursor",
                attrs: {
                  "width": "95%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_downward")]) : _vm._e()])])]
            }
          }, {
            key: "expand",
            fn: function(props) {
              return [(props.item.children != '') ? _c('v-data-table', {
                staticClass: "elevation-1 subTable2",
                attrs: {
                  "headers": _vm.regionHeader,
                  "search": _vm.search,
                  "items": props.item.children,
                  "hide-actions": "",
                  "disable-initial-sort": "",
                  "rows-per-page-items": [20, 40, 60, 80, 100]
                },
                scopedSlots: _vm._u([{
                  key: "items",
                  fn: function(props) {
                    return [_c('tr', [_c('td', {
                      staticClass: "leveltwo",
                      attrs: {
                        "width": "5%"
                      }
                    }, [_c('v-switch', {
                      on: {
                        "change": function($event) {
                          return _vm.fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)
                        }
                      },
                      model: {
                        value: (props.item.selected),
                        callback: function($$v) {
                          _vm.$set(props.item, "selected", $$v)
                        },
                        expression: "props.item.selected"
                      }
                    })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
                      staticClass: "cursor",
                      attrs: {
                        "width": "95%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
                      staticClass: "cursor",
                      attrs: {
                        "width": "95%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_downward")]) : _vm._e()])])]
                  }
                }, {
                  key: "expand",
                  fn: function(props) {
                    return [(props.item.children != '') ? _c('v-data-table', {
                      staticClass: "elevation-1 subTable3",
                      attrs: {
                        "headers": _vm.regionHeader,
                        "search": _vm.search,
                        "items": props.item.children,
                        "hide-actions": "",
                        "disable-initial-sort": "",
                        "rows-per-page-items": [20, 40, 60, 80, 100]
                      },
                      scopedSlots: _vm._u([{
                        key: "items",
                        fn: function(props) {
                          return [_c('tr', [_c('td', {
                            staticClass: "levelthree",
                            attrs: {
                              "width": "5%"
                            }
                          }, [_c('v-switch', {
                            on: {
                              "change": function($event) {
                                return _vm.fncCheckRegionSetup(props.item.loc_id, props.item.selected, props.item.parent)
                              }
                            },
                            model: {
                              value: (props.item.selected),
                              callback: function($$v) {
                                _vm.$set(props.item, "selected", $$v)
                              },
                              expression: "props.item.selected"
                            }
                          })], 1), _vm._v(" "), (props.expanded == true) ? _c('td', {
                            staticClass: "cursor",
                            attrs: {
                              "width": "95%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
                            staticClass: "cursor",
                            attrs: {
                              "width": "95%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [_vm._v(_vm._s(props.item.name) + " "), (props.item.children && props.item.children.length != 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_downward")]) : _vm._e()])])]
                        }
                      }], null, true)
                    }) : _vm._e()]
                  }
                }], null, true)
              }) : _vm._e()]
            }
          }], null, true)
        }) : _vm._e()]
      }
    }], null, false, 925584337)
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('p', [_vm._v("Please select a logo to upload ( Max size: 5mb )")]), _vm._v(" "), _c('input', {
    staticClass: "fileUpload",
    attrs: {
      "type": "file",
      "id": "quoteFile"
    },
    on: {
      "change": _vm.fncSetImageObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fileHolder"
  }, [_c('p', [_vm._v("Drag & Drop / Click to Add Files")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.fileName))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [(this.branchLogo == '') ? _c('p', [_c('br'), _c('strong', [_vm._v("No logo has been uploaded")])]) : _vm._e(), _vm._v(" "), (this.branchLogo != '') ? _c('p', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "clear": "both",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncResetLogo.apply(null, arguments)
      }
    }
  }, [_vm._v("Remove Logo")])]) : _vm._e(), _vm._v(" "), (this.branchLogo != '') ? _c('img', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "src": this.branchLogo,
      "width": "300"
    }
  }) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 4,
    staticClass: "pl-4 pr-4 pt-0 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Bank Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Bank Name",
      "required": "",
      "rules": _vm.bankRules,
      "solo": ""
    },
    model: {
      value: (_vm.branchBankName),
      callback: function($$v) {
        _vm.branchBankName = $$v
      },
      expression: "branchBankName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Bank Branch Code:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Bank Branch Code",
      "required": "",
      "rules": _vm.bankRules,
      "solo": ""
    },
    model: {
      value: (_vm.branchBankCode),
      callback: function($$v) {
        _vm.branchBankCode = $$v
      },
      expression: "branchBankCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Account Number:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Account Number",
      "required": "",
      "rules": _vm.bankRules,
      "solo": ""
    },
    model: {
      value: (_vm.branchBankAccountNumber),
      callback: function($$v) {
        _vm.branchBankAccountNumber = $$v
      },
      expression: "branchBankAccountNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Account Type:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Account Type",
      "required": "",
      "rules": _vm.bankRules,
      "solo": ""
    },
    model: {
      value: (_vm.branchBankAccountType),
      callback: function($$v) {
        _vm.branchBankAccountType = $$v
      },
      expression: "branchBankAccountType"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 5,
    staticClass: "pl-4 pr-4 pt-0 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Terms and Conditions:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Terms and Conditions",
      "required": "",
      "rules": _vm.termRules,
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchTnc),
      callback: function($$v) {
        _vm.branchTnc = $$v
      },
      expression: "branchTnc"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 6,
    staticClass: "pl-4 pr-4 pt-0 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "screenTip"
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v("\n                            If a specific department is not mapped to a pricelist the calculator will use the pricelist mapped to 'All\n                            departments'. If that is not set it will use the default pricelist."), _c('br'), _vm._v(" "), _c('b', [_vm._v("Note: ")]), _vm._v("Department to store pricing is only used if configured in the app.\n                          ")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Pricelist")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.pricelistList,
      "label": "Pricelist",
      "item-value": "pl_id",
      "item-text": "pl_name",
      "autocomplete": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.branchPricelist),
      callback: function($$v) {
        _vm.branchPricelist = $$v
      },
      expression: "branchPricelist"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("* future ranges will be added in due course")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addressSelected == false) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddDepartment()
      }
    }
  }, [_vm._v("Save")]) : _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddBranch()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}